import { MessageCircle, Phone } from "lucide-react";
import { site } from "@/content/site";

export function FloatingContact() {
  const phone = site.phone.replaceAll(" ", "");

  return (
    <div className="fixed bottom-5 right-4 z-50 hidden gap-3 sm:grid" aria-label="Quick contact">
      <a
        href={`https://wa.me/91${phone}`}
        aria-label="WhatsApp Swargaseema"
        className="grid size-12 place-items-center rounded-full bg-[#22a45a] text-white shadow-[0_12px_30px_rgba(23,60,49,0.25)]"
      >
        <MessageCircle size={22} />
      </a>
      <a
        href={`tel:${phone}`}
        aria-label="Call Swargaseema"
        className="grid size-12 place-items-center rounded-full bg-[var(--gold-strong)] text-[var(--ink)] shadow-[0_12px_30px_rgba(23,60,49,0.25)]"
      >
        <Phone size={21} />
      </a>
    </div>
  );
}
